import React from 'react';
import { TutorCancelBookingModal } from './tutor-cancel-booking-modal.component';
import { useTutorCancelBookingModalService } from './tutor-cancel-booking-modal.service';
import type { TutorCancelBookingModalContainerProps } from './tutor-cancel-booking-modal.types';

export const TutorCancelBookingModalContainer = (
  props: TutorCancelBookingModalContainerProps,
) => {
  const serviceProps = useTutorCancelBookingModalService(props);
  return <TutorCancelBookingModal {...serviceProps} />;
};
